const texto = (v: unknown): string => (v == null ? '' : String(v).trim())

/**
 * Acha a conversa do par numa listagem já filtrada pela API.
 *
 * Casa `personId`/`professionalId` (camelCase ou snake_case). A única conversa
 * da lista só vale quando o item **não traz** os ids: se trouxer ids diferentes
 * dos pedidos, é de outro par, e quem chama escreve em cima do resultado
 * (`reopen`, `presence/ensure`).
 */
export function acharConversaDoPar<T extends object>(
  lista: T[],
  personId: string,
  professionalId: string
): T | undefined {
  const idsDe = (c: T) => {
    const r = c as Record<string, unknown>
    return {
      pessoa: texto(r.personId ?? r.person_id),
      profissional: texto(r.professionalId ?? r.professional_id),
    }
  }

  const exata = lista.find((c) => {
    const { pessoa, profissional } = idsDe(c)
    return pessoa === personId && profissional === professionalId
  })
  if (exata) return exata

  if (lista.length === 1) {
    const { pessoa, profissional } = idsDe(lista[0])
    if (!pessoa && !profissional) return lista[0]
  }
  return undefined
}
